<template>
  <div style="width: 100%;height: 100%;overflow:auto;">
    <div style="margin:10px 0 10px 10px;">销售合同信息：</div>
    <el-form label-width="150px" style="margin: 10px;border: 1px solid #ececec">
      <el-row style="margin-top: 15px">
        <el-col :span="11">
          <el-form-item label="合同编号：">
            <el-select v-model="contract_no" filterable remote :remote-method="getContractRemote" :disabled="this.is_edit"
                       @change="getProductInfo"  style="width: 100%;">
              <el-option v-for="item in contractList" :key="item.contract_no" :label="item.contract_no" :value="item.contract_no" ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="合同当前期数：">
            <el-select v-model="contract_phase"  style="width: 100%;" @change="getProductInfo" :disabled="this.is_edit">
              <el-option v-for="phaseItem in phaseList" :key="phaseItem" :label="phaseItem" :value="phaseItem"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="企业名称：">
            <el-input v-model="company_name" style="width: 100%;" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div style="margin:10px 0 10px 10px;">合同销售产品清单：</div>

    <el-form v-for="item in productInfoList" :key="item.id" label-width="150px"
             style="margin: 10px;border: 1px solid #ececec">
      <el-row style="margin-top: 15px;">
        <el-col :span="22">
          <el-form-item label="产品名称：">
            <el-cascader v-model="item.product_id" :options="productList" style="width: 100%"
                         :show-all-levels="false" placeholder="选择产品" :props="props" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="单位：">
            <el-input v-model="item.unit" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="数量：">
            <el-input v-model="item.cnt" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="销售单价：">
            <el-input v-model="item.sales_price" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="销售总价：">
            <el-input v-model="item.sales_total_price" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="进货来源：">
            <el-select v-model="item.supplier_id" disabled>
              <el-option v-for="supplierItem in supplierList" :key="supplierItem.id" :label="supplierItem.name_key" :value="supplierItem.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="业务归属：">
            <el-select v-model="item.belong_area" disabled>
              <el-option v-for="company in companyList" :key="company.value" :label="company.label" :value="company.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="是否需要采购：">
            <el-switch v-model="item.is_need_purchase" :active-value="true" :inactive-value="false"  @change="showPurchaseProduct(item)"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="授权方式：">
            <el-select v-model="item.authorize_type" disabled>
              <el-option v-for="typeItem in authorizeTypeList" :key="typeItem.value" :label="typeItem.name"
                         :value="typeItem.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <template v-if="item.is_need_purchase">
          <el-form v-for="purchaseProduct in item.purchaseProductList" label-width="150px"
                   style="width: 100%;margin: 10px;border: 1px solid #ececec" >
            <el-row>
          <el-col :span="11" style="margin-top: 10px">
            <el-form-item label="采购序号：">
              <el-input v-model="purchaseProduct.id" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" style="margin-top: 10px">
            <el-form-item label=" ">
              <el-button type="danger" v-if="!this.is_edit" @click="delPurchaseProduct(purchaseProduct)"
                         :disabled="purchaseProduct.have_data">删除记录</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="供应商：" required>
              <el-select v-model="purchaseProduct.supplier_id" :disabled="purchaseProduct.have_data">
                <el-option v-for="supplierItem in supplierList" :key="supplierItem.id" :label="supplierItem.name_key" :value="supplierItem.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="采购日期：" required>
              <el-date-picker v-model="purchaseProduct.purchase_date" value-format="YYYY-MM-DD" :disabled="purchaseProduct.have_data"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="采购品：" required>
              <el-cascader v-model="purchaseProduct.product_id" :options="productList" style="width: 100%"
                           :show-all-levels="false" placeholder="选择产品" :props="props" :disabled="purchaseProduct.have_data"
                           clearable filterable @change="getProductInfoById(purchaseProduct)"/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="授权方式：" required>
              <el-select v-model="purchaseProduct.authorize_type"  @change="getProductPrice(purchaseProduct)" :disabled="purchaseProduct.have_data">
                <el-option v-for="typeItem in authorizeTypeList" :key="typeItem.value" :label="typeItem.name" :value="typeItem.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="采购公司：" required>
              <el-select v-model="purchaseProduct.purchase_company" :disabled="purchaseProduct.have_data">
                <el-option v-for="company in companyList" :key="company.value" :label="company.label"
                           :value="company.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="单位：">
              <el-input v-model="purchaseProduct.unit" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="采购数量：" required>
              <el-input-number v-model="purchaseProduct.cnt" :min="0" @change="calculateAllPrice" :disabled="purchaseProduct.have_data"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="标准单价：">
              <el-input v-model="purchaseProduct.price" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="标准总价：">
              <el-input v-model="purchaseProduct.total_price" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="折扣率(%)：" required>
              <el-input-number v-model="purchaseProduct.discount_rate" :min="0" :max="100" @change="calculateAllPrice" :disabled="purchaseProduct.have_data"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="折扣号：">
              <el-input v-model="purchaseProduct.discount_no" :disabled="purchaseProduct.have_data"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="折扣后单价：">
              <el-input v-model="purchaseProduct.discount_after_price" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="折扣后总价：">
              <el-input v-model="purchaseProduct.discount_after_total_price" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="折扣减免单价：">
              <el-input v-model="purchaseProduct.discount_price" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="折扣减免总价：">
              <el-input v-model="purchaseProduct.discount_total_price" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="备注：">
              <el-input v-model="purchaseProduct.remark" type="textarea" rows="2" clearable :disabled="purchaseProduct.have_data"></el-input>
            </el-form-item>
          </el-col>
              </el-row>
          </el-form>
          <el-col>
            <el-form-item>
              <el-button v-if="!this.is_edit" type="primary" @click="addPurchaseProduct(item)" >新增采购记录</el-button>
            </el-form-item>
          </el-col>
        </template>


        <el-col :span="11">
          <el-form-item label="合计采购金额：">
            <el-input v-model="item.purchase_total_price" disabled></el-input>
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <div style="text-align: center;margin-top: 10px;margin-bottom: 10px;">
      <el-button v-if="!is_edit" type="primary" style="width: 150px" @click="savePurchaseData">保存</el-button>
      <el-button v-else type="primary" style="width: 150px" @click="updatePurchaseData">保存</el-button>
    </div>



  </div>
</template>

<script>
import {nanoid} from "nanoid";

export default {
  name: "ProcurementRecords",
  inject: ['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data() {
    return {
      contract_no:'',
      contract_phase:'',
      company_name:'',
      product_id:'',
      company_id:'',
      chance_id:'',
      is_edit:false,
      companyList:[],
      productList:[],
      productInfoList:[],
      supplierList:[],
      contractList:[],
      allContractList:[],
      phaseList:[],
      props: {
        emitPath:false,
        expandTrigger: 'hover',
        value: 'id',
        label: 'name'
      },

    }
  },

  computed: {
    authorizeTypeList() {
      return this.$store.getters['core/getDictList']('authorize_type');
    },
  },

  async created() {
    await this.getCompanyList();
    await this.initForm();

  },

  methods: {
    async initForm(){
      let isEdit = this.parentData.is_edit;//字段由query中新增一列得来
      if(isEdit){
        this.chance_id = this.parentData.chance_id;
        this.contract_no = this.parentData.contract_no;
        this.company_id = this.parentData.company_id;
        this.product_id = this.parentData.product_id;
        this.company_name = this.parentData['company_lib.name@company_id'];
        this.contract_phase = this.parentData.contract_phase;
        this.is_edit = true;
        await this.getProductInfo();
      }
      this.addLine();
      await this.getProductList();
      await this.getSupplierList();
      await this.getAllContractList();

    },

    async getProductInfo(){
      let params = {contract_no:this.contract_no,contract_phase:this.contract_phase}
      if(this.is_edit){
        params.product_id = this.product_id;
      }
      let data = await this.$http('purchaseService.getProductInfo',params);
      this.company_name = data.company_name;
      this.productInfoList = data.productInfoList;
      this.company_id = data.company_id;
      this.chance_id = data.chance_id;
      let phaseList = data.phaseList;
      for (let i = 0; i < phaseList.length; i++){
        if(!this.phaseList.includes(phaseList[i].phase)){
          this.phaseList.push(phaseList[i].phase);
        }
      }
      if(this.is_edit){
        for(let item of this.productInfoList){
          if(item.purchaseProductList){
            for (let purchaseItem of item.purchaseProductList){
              if(purchaseItem.have_data){
                purchaseItem.have_data = false;
              }
            }
          }
        }
      }
      this.calculateAllPrice();

    },
    async savePurchaseData(){
      let params = {
        productInfoList: this.productInfoList,
        contract_no: this.contract_no,
        contract_phase: this.contract_phase,
        company_id:this.company_id,
        chance_id: this.chance_id,
      }
      await this.$http('purchaseService.savePurchaseData',params);
      await this.$fn.closeWindow();
      await this.$fn.search();
    },
    async updatePurchaseData(){
      let params = {
        productInfoList: this.productInfoList,
        contract_no: this.contract_no,
        contract_phase: this.contract_phase,
        company_id:this.company_id,
        chance_id: this.chance_id,
      }
      await this.$http('purchaseService.updatePurchaseData',params);
      await this.$fn.closeWindow();
      await this.$fn.search();
    },
    //根据产品id和授权方式获取价格
    async getProductPrice(item){
      let params = {product_id:item.product_id,authorize_type:item.authorize_type}
      let data = await this.$http('purchaseService.getProductPrice',params);
      item.price = data.price;
      if(item.cnt){
        item.total_price = item.cnt * item.price;
      }
      this.calculateAllPrice();
    },
    showPurchaseProduct(item){
      if(item.is_need_purchase === true){
        item.purchaseProductList = [];
        item.purchaseProductList.push({
          id:nanoid(),
          supplier_id:item.supplier_id,
        })
      }else {
        item.purchaseProductList = [];
      }
      this.calculateAllPrice();
    },
    async getCompanyList(){
      this.companyList = await this.$http('crmTeamService.getCompanyList');
    },


    async getProductInfoById(item){
      if(!item.product_id){
        item.code = '';
        item.unit = '';
        return;
      }
      let params = {product_id:item.product_id}
      let product = await this.$http('crmProductService.getProductById',params);
      item.code = product.code;
      item.unit = product.unit;
    },
    //计算所有的的价格
    calculateAllPrice(){
      if(!this.productInfoList){
        return;
      }
      for (let product of this.productInfoList){
        product.purchase_total_price = 0;
        if(product.cnt){
          product.sales_price = Number((product.sales_total_price / product.cnt).toFixed(2));
          if(product.purchaseProductList){
            for (let purchaseProduct of product.purchaseProductList){
              if(purchaseProduct.price){
                purchaseProduct.total_price = purchaseProduct.price * purchaseProduct.cnt;
              }
              if(purchaseProduct.discount_rate && purchaseProduct.cnt){
                purchaseProduct.discount_after_price = Number((purchaseProduct.price * purchaseProduct.discount_rate * 0.01).toFixed(2));
                purchaseProduct.discount_after_total_price = Number((purchaseProduct.discount_after_price * purchaseProduct.cnt).toFixed(2));
                purchaseProduct.discount_price = Number((purchaseProduct.price - purchaseProduct.discount_after_price).toFixed(2));
                purchaseProduct.discount_total_price = Number((purchaseProduct.total_price - purchaseProduct.discount_after_total_price).toFixed(2));
              }
              if(!purchaseProduct.discount_price){
                purchaseProduct.discount_price = 0;
              }
              if(!purchaseProduct.discount_total_price){
                purchaseProduct.discount_total_price = 0;
              }
              if(!purchaseProduct.discount_after_price){
                purchaseProduct.discount_after_price = 0;
              }
              if(!purchaseProduct.discount_after_total_price){
                purchaseProduct.discount_after_total_price = 0;
              }
              product.purchase_total_price = product.purchase_total_price + purchaseProduct.discount_after_total_price;
            }
          }
        }
      }
    },
    //获取产品列表
    async getProductList(){
      this.productList = await this.$http('crmDsService.getCatalogWithProducts');
    },
    //获取供应商列表
    async getSupplierList(){
      this.supplierList = await this.$http('crmDsService.getSupplierList');
    },
    addPurchaseProduct(item){
      if(item.purchaseProductList){
        item.purchaseProductList.push({
          id:nanoid(),
        })

      }
    },
    delPurchaseProduct(purchaseProduct){
      let id = purchaseProduct.id;
      this.productInfoList.forEach(item=>{
        if(item.purchaseProductList){
        let index = item.purchaseProductList.findIndex(purchaseProduct=>purchaseProduct.id === id);
        item.purchaseProductList.splice(index,1)
        }
      })
    },
    addLine(){
      this.productList.push({
        id: nanoid(),
      })
    },
    getContractRemote(value){
      if(!value){
        this.contractList = []
        return
      }
      this.contractList = [];
      for (let i = 0; i < this.allContractList.length; i++) {
        let item = this.allContractList[i]
        if(item && item.contract_no && item.contract_no.trim() !== ''){
          let no = item.contract_no.toLowerCase();
          value = value.toLowerCase();
          if(no.includes(value)){
            this.contractList.push(item)
          }
        }
      }
    },
    async getAllContractList(){
      this.allContractList = await this.$http('purchaseService.getAllContract');
    },

  }
}
</script>

<style scoped>

</style>